function configured(value) {
  return value ? "Configured" : "Not configured";
}

function modeLabel(mode) {
  return mode === "live" ? "Live mode" : "Test mode";
}

export default function IntegrationStatusCards({ settings, health }) {
  const stripe = settings?.integrations?.stripe || {};
  const resend = settings?.integrations?.resend || {};
  const orderingEnabled = settings?.ordering?.accepting_orders;
  const storefront = settings?.storefront || {};
  const storefrontStatus = storefront.maintenance_mode
    ? "Maintenance"
    : storefront.storefront_enabled === false
      ? "Disabled"
      : "Live";

  return (
    <div className="settings-summary-grid">
      <article>
        <span>Stripe</span>
        <strong>{modeLabel(stripe.mode)}</strong>
        <p>
          Publishable {configured(stripe.publishable_key_configured).toLowerCase()} | Secret {configured(stripe.secret_key_configured).toLowerCase()} | Webhook {configured(stripe.webhook_configured).toLowerCase()}
        </p>
      </article>
      <article>
        <span>Resend</span>
        <strong>{resend.configured ? "Connected" : "Pending"}</strong>
        <p>{resend.status || health?.resend || "Not connected"}</p>
      </article>
      <article>
        <span>Ordering</span>
        <strong>{health?.ordering || (orderingEnabled ? "enabled" : "disabled")}</strong>
        <p>{orderingEnabled ? "Taking orders" : "Orders paused"}</p>
      </article>
      <article>
        <span>Storefront</span>
        <strong>{storefrontStatus}</strong>
        <p>{health?.storefront || (storefront.storefront_enabled === false ? "disabled" : "enabled")}</p>
      </article>
    </div>
  );
}
